import StickyNotifyMe from '@cont/BatchGroup/NotifyMe/StickyNotifyMe';
import BatchPriceCard from './BatchPriceCard';
import { getIsEnrollmentClosed } from '../utils';

// when batch enrollment is closed for batch then show  notify otherwise show price section
const UnEnrolledBatchState = ({
  batchDetails,
  onJoinBatch,
  batchUID,
  slashPriceMessage
}) => {
  const { enrollmentEndDate, classType } = batchDetails;
  const isEnrollmentClose = getIsEnrollmentClosed(enrollmentEndDate);
  if (isEnrollmentClose) {
    return <StickyNotifyMe />;
  }
  return (
    <BatchPriceCard
      batchUID={batchUID}
      slashPriceMessage={slashPriceMessage}
      onJoinBatch={onJoinBatch}
      classType={classType}
      batchDetails={batchDetails}
    />
  );
};
export default UnEnrolledBatchState;
